import { useState } from 'react';

export default function Navigation() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm z-50 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <span className="text-2xl font-bold text-indigo-600">VOS-SYSTEM</span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap">
              Features
            </button>
            <button onClick={() => scrollToSection('security')} className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap">
              Security
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap">
              How It Works
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer whitespace-nowrap">
              Contact
            </button>
            <button onClick={() => scrollToSection('cta')} className="bg-indigo-600 text-white px-6 py-2 rounded-full hover:bg-indigo-700 transition-colors cursor-pointer whitespace-nowrap">
              Get Started
            </button>
          </div>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('features')} className="block w-full text-left text-gray-700 hover:text-indigo-600 py-2 cursor-pointer">
              Features
            </button>
            <button onClick={() => scrollToSection('security')} className="block w-full text-left text-gray-700 hover:text-indigo-600 py-2 cursor-pointer">
              Security
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="block w-full text-left text-gray-700 hover:text-indigo-600 py-2 cursor-pointer">
              How It Works
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left text-gray-700 hover:text-indigo-600 py-2 cursor-pointer">
              Contact
            </button>
            <button onClick={() => scrollToSection('cta')} className="bg-indigo-600 text-white px-6 py-2 rounded-full hover:bg-indigo-700 transition-colors w-full cursor-pointer whitespace-nowrap">
              Get Started
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
